import {EventEmitter} from 'events';

export default class Cache {
    static ee = new EventEmitter();
}
